import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import AppShell from './components/AppShell/AppShell';
import RequireAuth from './components/RequireAuth';
import LoginPage from './pages/login/LoginPage';
import WelcomePage from './pages/welcome/WelcomePage';
import HubPage from './pages/hub/HubPage';
import ThankYouPage from './pages/thankYou/ThankYouPage';
import BraillePage from './pages/games/braille/BraillePage';
import AvoidConsiderPage from './pages/games/avoidConsider/AvoidConsiderPage';
import GenderQuestPage from './pages/games/genderQuest/GenderQuestPage';
import DiversityQuizPage from './pages/games/diversityQuiz/DiversityQuizPage';

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/hub" element={<HubPage />} />
          <Route path="/games/braille" element={<BraillePage />} />
          <Route path="/games/avoid-consider" element={<AvoidConsiderPage />} />
          <Route path="/games/gender-quest" element={<GenderQuestPage />} />
          <Route path="/games/diversity" element={<DiversityQuizPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
